<template>
  <v-layout wrap class="job-details-wrap">
    <v-flex xs12>
      <div class="job-details">
        <h5 class="display-18 font-weight-medium mt-2">תיאור משרה</h5>
        <p class="ma-0 display-18" v-html="Description" />
      </div>
    </v-flex>
    <v-flex xs12>
      <JobRequirements
        :requirements="Requirements"
        class="job-requirements display-18"
      />

      <JobSalary
        :salary="SalaryRangeText"
        :requirements-empty="Salary > 0 ? true : false"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import JobRequirements from '@/components/Jobs_List/Job_Requirements/JobRequirements'

import JobSalary from '@/components/Jobs_List/Job_Salary/JobSalary'

export default {
  components: {
    JobRequirements,
    JobSalary,
  },
  props: {
    jobDetails: {
      type: Object,
      required: false,
      default: () => {},
    },
    canDisplay: {
      type: Boolean,
      required: false,
      default: true,
    },

    Requirements: {
      type: String,
      required: false,
      default: '',
    },
    Description: {
      type: String,
      required: false,
      default: ' ',
    },
    SalaryRangeText: {
      type: String,
      required: false,
      default: ' ',
    },
    Salary: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  methods: {
    log(e) {
      e.stopPropagation()
      e.stopImmediatePropagation()
      e.preventDefault()
    },
  },
}
</script>

<style lang="scss" scoped>
.job-details-wrap {
  width: 100%;
}
.job-requirements {
  padding: 20px 0 0 0;
}

.job-desc {
  border-bottom: 2px solid #fff;
}
.url-sign {
  position: relative;
  bottom: 2px;
  right: 4px;
}
</style>
